export var Result;
(function (Result) {
    const OkTypeSymbol = Symbol('Result.ok');
    const ErrTypeSymbol = Symbol('Result.err');
    Result.ok = (value) => ({ type: OkTypeSymbol, value });
    Result.err = (value) => ({ type: ErrTypeSymbol, value });
    Result.isOk = (result) => (result === null || result === void 0 ? void 0 : result.type) === OkTypeSymbol;
    Result.isErr = (result) => (result === null || result === void 0 ? void 0 : result.type) === ErrTypeSymbol;
    Result.map = (mapFn) => (result) => Result.isErr(result) ? result : Result.ok(mapFn(result.value));
    Result.mapErr = (mapFn) => (result) => Result.isOk(result) ? result : Result.err(mapFn(result.value));
    Result.fold = (mapFn, mapErrFn) => (result) => Result.isOk(result)
        ? Result.ok(mapFn(result.value))
        : Result.err(mapErrFn(result.value));
    Result.unwrapThrow = (result, 
    // eslint-disable-next-line no-restricted-globals
    toStr = String) => {
        if (Result.isErr(result)) {
            throw new Error(toStr(result.value));
        }
        return result.value;
    };
    Result.unwrapOk = (result) => Result.isErr(result) ? undefined : result.value;
    Result.unwrapOkOr = (result, defaultValue) => (Result.isErr(result) ? defaultValue : result.value);
    Result.unwrapErr = (result) => Result.isErr(result) ? result.value : undefined;
    Result.unwrapErrOr = (result, defaultValue) => (Result.isErr(result) ? result.value : defaultValue);
    Result.expectToBe = (message) => (result) => {
        if (Result.isErr(result)) {
            throw new Error(message);
        }
        return result.value;
    };
    Result.fromPromise = (promise) => promise.then(Result.ok).catch((error) => Result.err(error));
})(Result || (Result = {}));
